import type { FaireProductEntity } from "../../entity_types/product";

export const p_5247tewrpq: FaireProductEntity = {
  token: "p_5247tewrpq",
  type: "product",
  name: "Chalcedony and silver - rectangular pendants",
  brandToken: "b_gy2hjqt9aj",
  brandName: "UniArt",
  imageUrl:
    "https://cdn.faire.com/fastly/eb2fd073b8f6e1af071bef43e23177bd3b34a43e9f2806b98384815e97a6aab2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/71bc20e825d19013b187d5db0ecf0fea127a7c81956d96d2eb9646526ab79c42.jpeg",
    "https://cdn.faire.com/fastly/191c2b5bda2c3d9b46b95c36957748ec9b5b449985be3ace476ddf27587bf370.jpeg",
    "https://cdn.faire.com/fastly/30001d1015b2d0c71b1ee8429141887fbb7bd33b825c33189e164e242785c795.jpeg",
    "https://cdn.faire.com/fastly/56fa0168afd21b8b0ea67805b6a3f4c6d22c5f846a5127bf46596968e13d37a6.jpeg",
    "https://cdn.faire.com/fastly/9f55a7c8247c16aee9a913087c856ad3fdfe2a6512c92f23c691ec0cacc4599d.jpeg",
    "https://cdn.faire.com/fastly/2b20d656fb58a70144a86f26eb857e9d80e2de5c7aef3933dc05b42ca713b988.jpeg",
    "https://cdn.faire.com/fastly/37ea4e7455908da5c3015eea1443f571073f9362f1891bd2001da824516840c4.jpeg",
    "https://cdn.faire.com/fastly/3b12ab7ff7c333c6639afa30134117d9f479a3d182123403d4b4419c84d46918.jpeg",
    "https://cdn.faire.com/fastly/d98193fe83b91969b368e1f1a4cb5c4cb7de7769f6fc783617f118094966d70a.jpeg",
    "https://cdn.faire.com/fastly/e9081eda5dda45a934663cfbf673cdeddefa0348e2addd265e9be6459eec927b.jpeg",
    "https://cdn.faire.com/fastly/d404f7684c438cf48586b89c0201d47a50eefc1720f4f251b549060450b61907.jpeg",
    "https://cdn.faire.com/fastly/7b42069c2e5e31eeff72067d5f21213273f2ac92a173af74f8f7d7d53608173e.jpeg",
    "https://cdn.faire.com/fastly/aabdcfe970edfd93877fb7e649aefdbe1503c138f4397894171e2bb3b3464316.jpeg",
    "https://cdn.faire.com/fastly/b863b65acc70b7ff8374f74f81185d2944322da669cd3d14084ff68e5082023e.jpeg",
    "https://cdn.faire.com/fastly/e404a26bf6fdc99fbde66cf36767000ab544822f033524ec06fe470b5318fbbf.jpeg",
    "https://cdn.faire.com/fastly/3296035b764da613ceb1539fdf00b15b8952dd5dbe9a2db2051c758ca86dbafa.jpeg",
    "https://cdn.faire.com/fastly/536e838993952f60389224aac6d6793a22ffdd274a46ec5fc89baa0d79f749ab.jpeg",
  ],
  priceDollars: 52.05,
  description:
    "Pendants made in sterling silver and banded blue chalcedony in a rectangular format.\n\nThey are 925 silver pendants with natural banded blue chalcedony gemstones in a rectangular shape.\n\nThey have a smooth, polished silver finish, featuring a very elegant and modern design.\n\nThere are 7 options to buy these sterling silver pendants. Each one is a unique and exclusive piece; the price varies according to the model:\n\nModel 1: 3.9 cm x 2.3 cm x 0.7 cm.\n\nModel 2: 4.2 cm x 2.6 cm x 0.7 cm.\n\nModel 3: 4.5 cm x 2.8 cm x 0.8 cm.\n\nModel 4: 4.4 cm x 2.4 cm x 0.8 cm.\n\nModel 5: 4.2 cm x 2.5 cm x 0.8 cm.\n\nModel 6: 3.9 cm x 2.6 cm x 0.8 cm.\n\nModel 7: 3.9 cm x 2.6 cm x 0.8 cm.\n\nApproximate measurements including the pendant bail.\n\nThe chain must be purchased separately (not included in the price).\n\nMade in certified 925 sterling silver and natural stone.",
  tags: [],
  msrpDollars: 104.09,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:34.456Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
